<template>
  <div class="modal-sidebar-wrapper">
    <div class="modal-sidebar">

      <!-- Sidebar Header -->
      <div class="modal-sidebar-header">
        <span title="Preview Document" class="view-doc">
          <a><i class="icon icon-view" @click="Events.$emit('openPreview')"></i></a>
        </span>
        <p>{{ $t('proposal_editor_modal.proposal_editor') }}</p>
        <span title="Close Document" class="close-modal" @click="$emit('closeDocumentSidebar')">
          <i class="icon icon-close"></i>
        </span>

        <ul class="sidebar-template-tabs">
          <li :class="{ 'active': parentSidebarTab === 'content' }" @click="parentSidebarTab = 'content'">{{ $t('proposal_editor_modal.sidebar_tabs.content') }}</li>
          <li :class="{ 'active': parentSidebarTab === 'modules' }" @click="parentSidebarTab = 'modules'">{{ $t('proposal_editor_modal.sidebar_tabs.modules') }}</li>
          <li :class="{ 'active': parentSidebarTab === 'setup' }" @click="parentSidebarTab = 'setup'; childSidebarTab = 'document'">{{ $t('proposal_editor_modal.sidebar_tabs.setup') }}</li>
        </ul>
      </div>

      <!-- Sidebar body -->
      <div class="modal-sidebar-body">

        <!-- Content tab -->
        <div v-if="parentSidebarTab === 'content'">
          <p class="modal-sidebar-header-text">{{ $t('proposal_editor_modal.content') }}</p>
          <ul class="content-blocks">
            <draggable :list="partsList" :options="{ group: { name: 'omega', pull: 'clone', put: false }, sort: false }" :clone="cloneNewPart">
              <li v-for="part in partsList" :key="part.id" class="part-list-button" @click="addPartToDocument(part)">
                <span>
                  <i class="icon" :class="part.icon"></i>
                  {{ part.title }}
                </span>
                <div class="document-drag-zone">{{ $t('proposal_editor_modal.drop_content_here') }}</div>
              </li>
            </draggable>
          </ul>
        </div>

        <!-- Modules tab -->
        <div v-if="parentSidebarTab === 'modules'">
          <p class="modal-sidebar-header-text">{{ $t('proposal_editor_modal.modules') }}</p>

          <div class="no-modules" v-if="modulesList !== false && modulesList.length <= 0">
            <img src="/images/sad.png">
            <p>{{ $t('proposal_editor_modal.no_modules') }}</p>
          </div>

          <ul class="content-blocks">
            <draggable :list="modulesList" :options="{ group: { name: 'omega', pull: 'clone', put: false }, sort: false }" :clone="cloneNewModule">
              <li v-for="module in modulesList" :key="module.id" class="part-list-button" @click="addModuleToDocument(module)">
                <span>
                  {{ module.title }}
                </span>
                <div class="document-drag-zone">{{ $t('proposal_editor_modal.drop_content_here') }}</div>
              </li>
            </draggable>
          </ul>
        </div>

        <!-- Set up tab -->
        <div v-if="parentSidebarTab === 'setup'">

          <!-- Sub tabs -->
          <ul class="sidebar-template-subtabs">
            <li @click="childSidebarTab = 'document'" :class="{ 'active': childSidebarTab === 'document' }">{{ $t('proposal_editor_modal.setup_tabs.document') }}</li>
            <li @click="childSidebarTab = 'recipients'" :class="{ 'active': childSidebarTab === 'recipients' }">{{ $t('proposal_editor_modal.setup_tabs.recipients') }}</li>
            <li @click="childSidebarTab = 'watchers'" :class="{ 'active': childSidebarTab === 'watchers' }">{{ $t('proposal_editor_modal.setup_tabs.watchers') }}</li>
          </ul>

          <!-- Document tab -->
          <div v-if="childSidebarTab === 'document'">

            <!-- Cover options -->
            <p class="modal-sidebar-header-text">{{ $t('proposal_editor_modal.cover_layout') }}</p>
            <ul class="cover-layout-options">
              <li :class="{ 'active': payload.cover.layout === 1 || !payload.cover.layout }">
                <a @click="$set(payload.cover, 'layout', 1)"><i class="icon icon-layout-1"></i></a>
              </li>
              <li :class="{ 'active': payload.cover.layout === 2 }">
                <a @click="$set(payload.cover, 'layout', 2)"><i class="icon icon-layout-2"></i></a>
              </li>
              <li :class="{ 'active': payload.cover.layout === 3 }">
                <a @click="$set(payload.cover, 'layout', 3)"><i class="icon icon-layout-3"></i></a>
              </li>
              <li :class="{ 'active': payload.cover.layout === 4 }">
                <a @click="$set(payload.cover, 'layout', 4)"><i class="icon icon-layout-4"></i></a>
              </li>
            </ul>

            <!-- Cover Background options -->
            <p class="modal-sidebar-header-text">{{ $t('proposal_editor_modal.cover_background') }}</p>
            <ul class="cover-background-options">
              <li
                @click="$set(payload.cover, 'themeName', 'blank'); payload.cover.backgroundImage = null; payload.cover.backgroundColor = '#ffffff';payload.cover.color = '#000000';"
                :class="{ 'active': !payload.cover.backgroundImage && payload.cover.backgroundColor === '#ffffff' && payload.cover.color === '#000000' }">
                Blank
              </li>
              <li
                @click="$set(payload.cover, 'themeName', 'image'); payload.cover.backgroundColor = null; payload.cover.backgroundImage = '/images/doc-placeholder.jpg';payload.cover.color = '#FFFFFF';"
                :class="{ 'active': payload.cover.backgroundImage }">
                Image
              </li>
              <li
                @click="payload.cover.backgroundImage = null; payload.cover.backgroundColor = themes[0].backgroundColor; payload.cover.color = themes[0].color;"
                :class="{ 'active': payload.cover.backgroundColor && payload.cover.backgroundColor !== '#ffffff' }">
                Color
              </li>
            </ul>

            <!-- Background image  -->
            <div class="cover-background-section" v-show="payload.cover.backgroundImage">
              <p class="modal-sidebar-subheader-text">{{ $t('proposal_editor_modal.background_image') }} <span>{{ $t('proposal_editor_modal.recommended_size') }}</span></p>
              <dropzone @upload="updateCoverBackgroundImage" v-if="payload.cover.backgroundImage === '/images/doc-placeholder.jpg'"></dropzone>
              <img :src="payload.cover.backgroundImage" v-show="payload.cover.backgroundImage && payload.cover.backgroundImage !== '/images/doc-placeholder.jpg'" @click="resetDropzone()">
            </div>

            <!-- Color theme -->
            <div v-show="payload.cover.backgroundColor">
              <p class="modal-sidebar-subheader-text">{{ $t('proposal_editor_modal.color_theme') }}</p>
              <ul class="cover-bg-color">
                <li :class="{ 'selected': isCoverThemeSelected(theme) }" @click="changeCoverTheme(theme)" v-for="(theme, index) in themes" :key="index">
                  <span :style="{ 'background-color': theme.backgroundColor, 'color': theme.color }">a</span>
                </li>
              </ul>
            </div>

            <!-- Cover alignment -->
            <p class="modal-sidebar-header-text">{{ $t('proposal_editor_modal.cover_alignment') }}</p>
            <ul class="cover-alignment-options">
              <li :class="{ 'active': payload.cover.alignment === 'left' }">
                <i class="icon icon-align-left" @click="$set(payload.cover, 'alignment', 'left')"></i>
              </li>
              <li :class="{ 'active': !payload.cover.alignment || payload.cover.alignment === 'center' }">
                <i class="icon icon-align-center" @click="$set(payload.cover, 'alignment', 'center')"></i>
              </li>
            </ul>

            <!-- Font options -->
            <p class="modal-sidebar-header-text">{{ $t('proposal_editor_modal.document_font') }}</p>
            <div class="font-options">
              <multiselect
                v-model="payload.options.documentFont"
                :options="documentFontOptions"
                :searchable="false"
                :showLabels="false"
              ></multiselect>
            </div>

            <!--Paper size -->
            <p class="modal-sidebar-header-text">{{ $t('proposal_editor_modal.paper_size') }}</p>
            <ul class="paper-size-options">
              <li
                :class="{ 'active': payload.options.paperSize === 'a4' }"
                @click="payload.options.paperSize = 'a4'">A4</li>
              <li
                :class="{ 'active': !payload.options.paperSize || payload.options.paperSize === 'letter' }"
                @click="payload.options.paperSize = 'letter'">Letter</li>
            </ul>
          </div>
        </div>

        <!-- Recipients tab -->
        <div v-if="parentSidebarTab === 'setup' && childSidebarTab === 'recipients'">
          <p class="modal-sidebar-header-text">
            {{ $t('proposal_editor_modal.select_recipients') }}
            <a @click="Events.$emit('modalOpen', 'newContactModal')">
              <span><span>&#x0002B;</span> {{ $t('navigation.new_contact') }}</span>
            </a>
          </p>
          <div class="choose-contact">
            <multiselect
              v-model="payload.contacts"
              :options="contacts"
              track-by="id"
              label="name"
              :close-on-select="false"
              :clear-on-select="true"
              :multiple="true"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>

        <!-- Watchers tab -->
        <div v-if="parentSidebarTab === 'setup' && childSidebarTab === 'watchers'">
          <p class="modal-sidebar-header-text">
            {{ $t('proposal_editor_modal.select_watchers') }}
          </p>
          <div class="choose-contact">
            <multiselect
              v-model="watchersFiltered"
              :options="teamMembers"
              track-by="id"
              label="name"
              :close-on-select="false"
              :clear-on-select="true"
              :multiple="true"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-sidebar-footer">
        <span class="actions" slot="sidebar-footer">
          <a class="secondary-action" :href="'/document/' + payload.id + '/download'" @click="Events.$emit('documentDownloaded');"><i class="icon icon-download"></i></a>
          <a class="secondary-action" :href="'/document/' + payload.id + '/download/print'" @click="Events.$emit('documentDownloaded');" target="_blank"><i class="fa fa-lg fa-print"></i></a>
          <a class="button is-primary is-large" @click="Events.$emit('openDocumentSendModal')"><i class="icon icon-send"></i> {{ $t('proposal_editor_modal.send_proposal') }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';
  import DocumentSidebar from 'mixins/document-sidebar';

  export default {
    mixins: [API, DocumentSidebar],
    props: ['payload', 'documentLoaded'],
    data() {
      return {
        Events: window.Events,
        teamMembers: window.Spark.state.currentTeam.users,
        contacts: false,
        watchersFiltered: [],
        parentSidebarTab: 'content',
        childSidebarTab: '',
        showAutosave: false,
        modulesList: [],
        themes: require('settings/themeColors'),
        documentFontOptions: require('settings/documentFontOptions'),
        partsList: require('settings/documentPartsList'),
        defaultBackground: false
      }
    },
    beforeMount() {
      this.api().fetchTeamModules().then(modules => {
        this.modulesList = modules;
      });

      this.refreshContacts();
      this.Events.$on('createContact', (contact) => {
        this.payload.contacts.push(contact);
        this.refreshContacts();
      });
      this.Events.$on('updateContact', this.refreshContacts);
      this.Events.$on('archiveContact', this.refreshContacts);

      this.$on('closesendmodal', function() { // TODO : Oh I really hate this
        this.$emit('closesendmodal');
      });
    },
    methods: {
      refreshContacts() {
        this.api().fetchTeamContacts().then(contacts => {
          this.contacts = contacts;
        });
      },
      resetDropzone() {
        this.$set(this.payload.cover, 'backgroundImage', '/images/doc-placeholder.jpg');
      },
    },
    watch: {
      'payload.watchers'() {
        this.watchersFiltered = _.map(this.payload.watchers, (watcher) => {
          return watcher.user;
        });
      },
      watchersFiltered() {
        const currentWatchersList =
          _.pluck(
            _.pluck(
              this.payload.watchers,
              'user'
            ),
            'id'
          );
        const newWatchersList = _.pluck(this.watchersFiltered, 'id');

        // Get all current watchers that are not in the multiselect and remove
        // them
        let toUnwatch = _.difference(currentWatchersList, newWatchersList);
        _.each(toUnwatch, (userId) => {
          this.payload.watchers = _.reject(this.payload.watchers, (watcher) => {
            return watcher.user.id === userId;
          });

          this.api().unwatchDocument(this.payload.id, userId)
            .then(() => {
              (new Notyf()).confirm('User removed');
            });
        });

        // Get all current non-watchers that are in the multiselect and add
        // them
        let toWatch = _.difference(newWatchersList, currentWatchersList);
        _.each(toWatch, (userId) => {
          this.api().watchDocument(this.payload.id, userId)
            .then((watcher) => {
              this.payload.watchers.push({
                user: _.findWhere(this.teamMembers, { id: watcher.user_id })
              });
              (new Notyf()).confirm('User added');
            });
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";
  @import "resources/assets/sass/partial/document-sidebar";
</style>



// WEBPACK FOOTER //
// document-editor-sidebar.vue?8453f9ac